import { absolutePath } from "../absolutePath";

interface SearchFnProps {
  params?: Record<string, unknown>;
}

export const search = {
  communityMembers: {
    /* Enable multiple instances and operators */
    indexV2: ({ params = {} }: SearchFnProps) =>
      absolutePath("v2/admin/search/community_members", params, {
        arrayFormat: "indices",
      }),
  },
  contacts: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("v2/admin/search/contacts", params, {
        arrayFormat: "indices",
      }),
    indexV3: ({ params = {} }: SearchFnProps) =>
      absolutePath("v3/admin/search/contacts", params, {
        arrayFormat: "indices",
      }),
  },
};
